<template>
  <div>
    <div class="photo" style="height: 150px;width: 150px;" @mouseenter="pauseTimer" @mouseleave="resumeTimer">
      <transition :name="transitionName" mode="out-in">
        <img :key="index" :src="images[index]" onerror="this.onerror=null; this.src='/images/img404.png'" />
      </transition>
      <div class="preview">
        <i class="el-icon-arrow-left" @click="prev"></i>
        <i class="el-icon-view" @click="preview"></i>
        <i class="el-icon-arrow-right" @click="next"></i>
      </div>
    </div>
    <image-preview ref="imagePreview"></image-preview>
  </div>

</template>

<script>
export default {
  name: "ImageList",
  props: {
    images: { type: Array, require: true }
  },
  data() {
    return {
      index: 0,
      timer: null,
      transitionName: 'slide-left' // 默认向左滑动
    }
  },
  created() {
    this.startTimer();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    preview() {
      this.$refs.imagePreview.open(this.images, this.index);
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.transitionName = 'slide-left';
        this.next();
      }, 3000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    pauseTimer() {
      this.clearTimer();
    },
    resumeTimer() {
      if (!this.timer) {
        this.startTimer();
      }
    },
    prev() {
      this.transitionName = 'slide-right';
      let newIndex;
      if (this.index === 0) newIndex = this.images.length - 1;
      else newIndex = this.index - 1;
      this.$set(this, 'index', newIndex);
    },
    next() {
      this.transitionName = 'slide-left';
      let newIndex;
      if (this.index === this.images.length - 1) newIndex = 0;
      else newIndex = this.index + 1;
      this.$set(this, 'index', newIndex);
    }
  }
}
</script>

<style lang="scss" scoped>
.photo {
  position: relative;
  overflow: hidden;
  border-radius: 5px;
}

.photo img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.preview {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 22px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: black;
  color: white;
  opacity: 0;
  width: 150px;
  height: 150px;
}

.photo:hover .preview {
  opacity: 0.5;
  cursor: pointer;
}

/* 向左滑动效果 */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.8s ease;
  position: absolute;
}

.slide-left-enter {
  transform: translateX(100%);
}

.slide-left-leave-to {
  transform: translateX(-100%);
}

/* 向右滑动效果 */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.8s ease;
  position: absolute;
}

.slide-right-enter {
  transform: translateX(-100%);
}

.slide-right-leave-to {
  transform: translateX(100%);
}

//忽略作用域限制，把这个样式穿透作用到 .el-dialog__body 上
::v-deep .el-dialog__body {
  padding: 0 !important;
  margin: 0 !important;
}

::v-deep .el-dialog__header {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
